import { FormFieldTypes } from "../../../../components/finalForms/libs/data/formFieldType"
import { validationTypes } from "../../../../components/finalForms/libs/data/ValidationTypes"

const initState = {
    userId : null,
    projectId:null,
    selectDate: null
}

export const TimesheetReportFilterdata = {
    name: "TimesheetReport Form",
    initialState: initState,
    section: [
        {
            sectionId: 'TimesheetReportForm',
            title: "Filter",
            row: {},
            style: {
                sectionStyle: "col-lg-12 col-md-2",
            },
            wrapperTemplate: <div className="form-card row"></div>,
            fields: [
                {
                    id: "userId",
                    label: "User",
                    Field_Name: "User",
                    fieldType: FormFieldTypes.SELECT,
                    dataField: "userId",
                    fieldSetting: {
                      placeholder: "Please Select User",
                      allowSpace: true,
                      options: [],
                    },
                    validation: [{ type: validationTypes.REQUIRE }],
                    style: {
                      containerCss: "col-lg-4 col-md-4 validation-left-0",
                    },
                  },

                  {
                    id: "projectId",
                    label: "Project",
                    Field_Name: "projectId",
                    fieldType: FormFieldTypes.SELECT,
                    dataField: "projectId",
                    fieldSetting: {
                      placeholder: "Please Select Project",
                      allowSpace: true,
                      options: [],
                    },
                    style: {
                      containerCss: "col-lg-4 col-md-4 validation-left-0",
                    },
                  },

                  {
                    id: "selectDate",
                    label: "Date",
                    Field_Name: "selectDate",
                    fieldType: FormFieldTypes.DATEPICKER,
                    dataField: "selectDate",
                    fieldSetting: {
                      placeholder: "Please Select Date",
                      dateConfig: {
                        singleInputRangePicker: true,
                        monthsToShow: 2,
                        format: "dd/MM/yyyy",
                    }
                    },
                    style: {
                      containerCss: "col-lg-4 col-md-4 validation-left-0 mb-2",
                    },
                  },

            ]
        }
    ]
}

